import { ContextStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import * as React from 'react';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { getPropertyOffersInput } from 'stores/adapters/bex-api/property-info/property-info-input-adapter';
import { MultiItemStore } from 'stores/multi-item-store';

import { parse } from 'query-string';
import { PropertySearchCriteriaInput, PropertyTravelAdTrackingInfoInput, SearchOfferInput, ShoppingContextInput } from '__generated__/api';

export interface SharedUiPropertyOffersComponentProps {
  currentHotel?: CurrentHotelStore;
  multiItem?: MultiItemStore;
  context?: ContextStore;
  hideCtaButton?: boolean;
  hidePrice?: boolean;
  wrapPriceSummary?: boolean;
}

export interface SharedUiWrapperProps {
  inputs: {
    propertyId: string;
    shoppingContext: ShoppingContextInput;
    searchCriteria: PropertySearchCriteriaInput;
    travelAdTrackingInfo: PropertyTravelAdTrackingInfoInput | null;
    searchOffer: SearchOfferInput | null;
    referrer?: string;
  };
  context?: ContextStore;
  currentHotel?: CurrentHotelStore;
}

export const withSharedUiPropertyOffers = <F extends Record<string, unknown>>(SharedUiWrapper: React.FC<SharedUiWrapperProps>) => {
  const PropertyOffersComponent: React.FC<F & SharedUiPropertyOffersComponentProps> = inject(
    'currentHotel',
    'context',
    'multiItem'
  )(
    observer(({ currentHotel, context, multiItem, ...props }) => {
      const location = useLocation();
      const urlParameters: Partial<Record<string, string>> = parse(location.search);
      const { dateless, startDate, chkin, d1 } = urlParameters;
      const isDatedPdp = Boolean(!dateless && (startDate || chkin || d1));
      const datesAreGoingToBeHydrated = isDatedPdp && !currentHotel?.searchCriteria.startDate;

      if (!context || !currentHotel?.searchCriteria || !currentHotel.hotelId || datesAreGoingToBeHydrated) {
        return null;
      }

      const inputs = getPropertyOffersInput(context, currentHotel, urlParameters, multiItem?.multiItemContext ?? undefined);

      return <SharedUiWrapper inputs={inputs} {...props} />;
    })
  );
  PropertyOffersComponent.displayName = 'PropertyOffersComponent';

  return PropertyOffersComponent;
};
